import AuthService from './authService.js';
import PlanningDetailSnapshotItem from '../Domain/PlanningDetailSnapshotItem.js';

class PlanningDetailSnapshotService {
  static GetByPlanningDetailId(planningDetailId, limit = null) {
    let url = `api/PlanningDetailSnapshot/GetByPlanningDetailId?planningDetailId=${planningDetailId}`;
    if (limit) {
      url += `&limit=${limit}`;
    }
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetByPricingId(pricingId) {
    const url = `api/PlanningDetailSnapshot/GetByPricingId?pricingId=${pricingId}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetSnapshotListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    const url = `/api/PlanningDetailSnapshot/GetAllBySearching?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBSnapshots(items) {
    if (!items) return [];
    return items.map((item) => new PlanningDetailSnapshotItem(item));
  }
}

export default PlanningDetailSnapshotService;
